import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const CasesField = ({ casefoldersSelectOptions }) => {
  return (
    <Field name="my_cases" parse={({ value }) => value}>
      {({ input }) => (
        <Fragment>
          <label>Search What</label>
          <Select {...input} clearable={false} options={casefoldersSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

CasesField.propTypes = {
  casefoldersSelectOptions: PropTypes.array.isRequired,
};

export default CasesField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/CasesField.jsx